'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = Tabs;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./tabs.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Tabs Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function Tabs(props) {
    var _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;


    return (0, _jsx3.default)('ul', {
        className: 'sb-tabs',
        id: id
    }, void 0, props.children);
}
// css
//# sourceMappingURL=Tabs.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/tabs/Tabs.js
// module id = 615
// module chunks = 0